<template>
  <div>
    <!-- <CCTV-Menu-Top /> -->
    <CCTV-Map />
    <br>
    <CCTV-Table />
  </div>
</template>

<script>
// import CCTVMenuTop from '@/views/cctv/sub/CCTVMenuTop.vue'
import CCTVMap from '@/views/scada/sub/ScadaMap.vue'
import CCTVTable from '@/views/scada/sub/ScadaTable.vue'

export default {
  components: {
    // CCTVMenuTop,
    CCTVMap,
    CCTVTable,
  },
}
</script>

<style>

</style>
